import React from 'react';
import { Field, Form } from 'react-final-form';

import { renderSelectField } from '../../../../Utils/renderField/renderField';
import { required } from '../../../../../../utility/validation';
import {
    ABANDONMENT,
    DESERTED,
    ACTIVE,
    NOT_ENTER,
    DESERTED_OPTIONS_,
    DESERTED_OPTIONS_LEVELING,
} from '../../../../../../utility/constants';

const STATUS_OPTIONS = [
    { value: ACTIVE, label: 'Activo' },
    { value: DESERTED, label: 'Deserto' },
    { value: NOT_ENTER, label: 'No ingresó' },
];

const DisabledBeneficiaryLevelingForm = ({ initialValues, onSubmit }) => {
    return (
        <Form initialValues={{ ...initialValues }} onSubmit={onSubmit}>
            {({ handleSubmit, submitting, values }) => {
                return (
                    <form
                        name="beneficiaryForm"
                        className="form-validate mb-lg"
                        onSubmit={handleSubmit}
                    >
                        <div className="d-flex flex-column flex-lg-row">
                            <div className="form-group has-feedback m-2 flex-1">
                                <label htmlFor="status_leveling">
                                    Estado de nivelación del usuario
                                </label>
                                <Field
                                    name="status_leveling"
                                    component={renderSelectField}
                                    options={STATUS_OPTIONS}
                                    isSearchable={false}
                                    validate={required}
                                    modal={true}
                                    className="form-control w-100"
                                />
                            </div>
                        </div>

                        {values.status_leveling === DESERTED && (
                            <div className="d-flex flex-column flex-lg-row">
                                <div className="form-group has-feedback m-2 flex-1">
                                    <label htmlFor="desertion_reason_leveling">
                                        Razón de Deserción
                                    </label>
                                    <Field
                                        name="desertion_reason_leveling"
                                        component={renderSelectField}
                                        isSearchable={false}
                                        type="text"
                                        validate={required}
                                        modal={true}
                                        options={DESERTED_OPTIONS_LEVELING}
                                        className="form-control w-100"
                                    />
                                </div>
                            </div>
                        )}

                        <div className="container bg-light mt-4">
                            <div className="col-md-12 text-center">
                                <button
                                    type="submit"
                                    className="btn btn-primary "
                                    disabled={submitting}
                                >
                                    Guardar
                                </button>
                            </div>
                        </div>
                    </form>
                );
            }}
        </Form>
    );
};

export default DisabledBeneficiaryLevelingForm;
